import React from "react";
class Infrastructure extends React.Component {
  render() {
    return (
      <main>
        <div className="mainBody">
          <div className="bannerBlock">
            <div
              style={{
                position: "absolute",
                right: "0px",
                width: "250px",
                height: "150px",
                backgroundimage: "url(images/Services.png)",
                backgroundposition: "-0px -100px",
              }}
            ></div>
            <div className="bannerContent">
              <div class="content">
                <span class="pageTitle">CLOUD INFRASTRUCTURE</span>
                <br />
                <span class="subTitle">
                  Building intelligent, scalable cloud infrastructure with AI-enhanced
                  <br />
                  automation and Infrastructure as Code...
                </span>
              </div>
            </div>
          </div>
          <div className="content padSmall">
            <p>
              At Sarithm, we design and manage cloud infrastructure that leverages AI tools and 
              modern automation to deliver transparency, efficiency, and cost-effectiveness. 
              We believe infrastructure transparency leads to higher efficiency in infrastructure 
              management, and we use AI-powered tools to maintain this visibility as your 
              infrastructure scales.
            </p>
            <p>
              <b>AI-Enhanced Infrastructure Management:</b> We leverage <b>Cursor</b> to accelerate 
              our Infrastructure as Code (IaC) development, enabling faster creation and optimization 
              of infrastructure modules. <b>ChatGPT</b> assists us in generating comprehensive 
              documentation, analyzing infrastructure patterns, and providing intelligent recommendations 
              for optimization. <b>n8n</b> powers our infrastructure automation workflows, enabling 
              seamless integration between cloud services, monitoring systems, and deployment pipelines.
            </p>
            <p>
              <b>Infrastructure as Code with Terraform:</b> We use <b>Terraform</b>, the industry-leading 
              Infrastructure as Code solution, to build, manage, and version control your cloud 
              infrastructure. Our approach is simple: write code, run plan, and apply code to build 
              infrastructure. We maintain a library of <b>ready-to-use modules</b> for widely used 
              resources, which means <b>faster, cost-effective, and efficient</b> infrastructure deployment. 
              We customize code to fit your existing continuous delivery pipeline, ensuring seamless 
              integration with your DevOps workflows.
            </p>
            <p>
              <b>Intelligent Automation with Atlantis:</b> We implement <b>Atlantis</b>, a Terraform 
              pull request automation solution, to ensure safe and controlled infrastructure changes. 
              Our customized Atlantis solution, built using ECS, SSM, and assume roles, allows us to 
              apply Terraform modules to multiple accounts with required variations using Terraform 
              workspaces. Key benefits include: [1] Never applying Terraform code without peer review, 
              ensuring security and compliance. [2] Fully automated GitOps implementation, reducing 
              manual errors and accelerating deployments.
            </p>
            <p>
              <b>Infrastructure Transparency and Tracking:</b> As infrastructure grows, maintaining 
              visibility becomes challenging. Our AI-enhanced best practices and automation tools allow 
              your SysOps and DevOps teams to track all dynamic infrastructure changes in real-time. 
              AI-driven analytics help identify optimization opportunities, predict capacity needs, and 
              detect potential issues before they impact operations.
            </p>
            <p>
              <b>Why Choose Us:</b> [1] We are passionate about cloud infrastructure and stay current 
              with the latest technologies and AI tools. [2] We understand the critical balance between 
              speed and safety, ensuring rapid delivery without compromising security or reliability. 
              [3] We customize solutions to fit your existing workflows, whether you're working with 
              small optimization projects or large-scale cloud transformations.
            </p>
            <p>
              From multi-region network architecture to serverless infrastructure and cloud migrations, 
              we deliver intelligent, scalable, and cost-effective cloud infrastructure solutions that 
              grow with your business.
            </p>
            <br />
            <br />
            <br />
          </div>
        </div>
        <div style={{ clear: "both" }}></div>
      </main>
    );
  }
}
export default Infrastructure;
